import ty from "tinycolor2";

export const useLayoutStore = defineStore("my-layout", () => {
  const layout: Record<string, [Ref<any, any>, DOMRect]> = {};

  const useRef = (m: string) => {
    const t = layout[m];
    // console.log(layout);
    if (t) return t;
    const el = shallowRef();
    const rect = useElementBounding(el);
    return (layout[m] = [el, reactive(rect) as any]) as [
      Ref<any, any>,
      DOMRect
    ];
  };

  return {
    useRef,
  };
});

export const useTyColor = (colorObj: Record<number, string>, init = 0) => {
  // step 0到100
  const step = ref(init);
  const range = _numInRange(0, 100);
  const currentColor = computed(() => {
    const radio = range(step.value);
    return ty.mix(colorObj[0], colorObj[100], radio).toRgbString()
  });
  return {
    currentColor,
    step,
  };
};
